<script setup lang="ts">
import AppHeader from '@/components/layout/AppHeader.vue'
import AppFooter from '@/components/layout/AppFooter.vue'
</script>

<template>
  <v-app>
    <AppHeader />
    <v-main class="bg-slate-50">
      <router-view />
    </v-main>
    <AppFooter />
  </v-app>
</template>
